import React from "react"
import { FEATURE_FLAGS } from '@/config/featureFlag';
import { Route, Navigate, Routes } from "react-router-dom"
import Login from "@/pages/Login"
import NotFound from "@/pages/NotFound"
import { ProtectedRoute } from "@/components/auth/ProtectedRoute"
import InvitationAccept from "@/pages/InvitationAccept"
import AccountSetup from "@/pages/AccountSetup"
import BusinessDashboard from "@/pages/BusinessDashboard"
import UserSettings from "@/pages/UserSettings"
import PortfolioSettings from "@/pages/PortfolioSettings"
import Index from "@/pages/Index"
import ResetPassword from "@/pages/ResetPassword"
import PasswordResetConfirm from "@/pages/PasswordResetConfirm"
import GoCampaignPage from "@/pages/GoCampaignPage"
import CreateFirstBusiness from "@/pages/CreateFirstBusiness"
import EditBusinessPage from "@/components/business/onboarding/modals/EditBusinessPage"
import BusinessSettings from "@/pages/BusinessSettings"
import FakeBusinessCreator from "@/pages/FakeBusinessCreator"

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/password-reset-confirm"
        element={<PasswordResetConfirm />}
      />
      <Route path="/__/auth/action" element={<PasswordResetConfirm />} />
      <Route path="/invitation/:token" element={<InvitationAccept />} />
      <Route path="/account-setup" element={<AccountSetup />} />

      {/* Make create-first-business a completely public route - ensure it's not wrapped in ProtectedRoute */}
      <Route path="/create-first-business" element={<CreateFirstBusiness />} />

      {/* Business onboarding route - public as well */}
      <Route
        path="/business/:businessId/onboarding"
        element={<GoCampaignPage />}
      />

      {/* Protected routes - including index/home route */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Index />
          </ProtectedRoute>
        }
      />

      <Route
        path="/portfolios"
        element={
          <ProtectedRoute>
            <Index />
          </ProtectedRoute>
        }
      />

      <Route
        path="/portfolio/:portfolioId/settings"
        element={
          <ProtectedRoute>
            <PortfolioSettings />
          </ProtectedRoute>
        }
      />

      {/* Add direct business route */}
      <Route
        path="/business/:businessId"
        element={
          <ProtectedRoute>
            <BusinessDashboard pageTitle="Business Dashboard" />
          </ProtectedRoute>
        }
      />

      {/* Business Edit route - controlled by ONBOARDING flag */}
      {FEATURE_FLAGS.ONBOARDING && (
        <Route
          path="/business/:businessId/edit"
          element={
            <ProtectedRoute>
              <EditBusinessPage />
            </ProtectedRoute>
          }
        />
      )}

      {/* Business Settings route - controlled by SETTINGS flag */}
      {FEATURE_FLAGS.SETTINGS && (
        <Route
          path="/business/:businessId/settings"
          element={
            <ProtectedRoute>
              <BusinessSettings />
            </ProtectedRoute>
          }
        />
      )}

      {/* User Settings route - controlled by SETTINGS flag */}
      {FEATURE_FLAGS.SETTINGS && (
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <UserSettings />
            </ProtectedRoute>
          }
        />
      )}

      {/* Business GoCampaign routes - controlled by ONBOARDING flag */}
      {FEATURE_FLAGS.ONBOARDING && (
        <Route
          path="/business/:businessId/gocampaign"
          element={
            <ProtectedRoute>
              <GoCampaignPage />
            </ProtectedRoute>
          }
        />
      )}

      {/* Add the new fake business creator page */}
      <Route
        path="/dev-tools"
        element={
          <ProtectedRoute>
            <FakeBusinessCreator />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
